import React from "react";
import { ReactController } from "../react_controller";
import { FormChannelControl } from "~/components/CollaborativeFormEditor/FormChannelControl";
import { CollaborativeFormEditor } from "~/components/CollaborativeFormEditor";
import { CollaborativeFormEditorWithReplay } from "@/components/CollaborativeFormEditor/CollaborativeFormEditorWithReplay";
import { stringToHslColor } from "~/components/AwarenessUsers/colors";
import PrimerStyleGuard from "~/components/PrimerStyleGuard";

const logFormUpdate = (ydoc) => {
  console.log("[formsync] Logging form update");
  const itemIdMap = ydoc.getMap("itemIdMap");
  const itemIdMapKeys = Array.from(itemIdMap.keys());
  const itemMaps = itemIdMapKeys.map((key) => ydoc.getMap(key));
  console.log("[formsync] Got form update", {
    itemIDs: itemIdMapKeys,
    itemMaps: itemMaps.map((map) => map.toJSON()),
    editorState: ydoc.getMap("editorState").toJSON(),
    history: ydoc.getArray("history").toJSON(),
  });
};

export class CollaborativeFormEditorController extends ReactController {
  connect() {
    const {id, eventId, assistantEnabled = false, ...props} = this.propsValue;

    if(!this.channelControl) {
      const {id, eventId, assistantEnabled = false, ...props} = this.propsValue;
      const awarenessUser = {
        name: props.user.name,
        initials: props.user.initials,
        id: Number(props.user.id),
        color: stringToHslColor(props.user.name),
        avatarUrl: props.user.avatarUrl,
      };

      this.channelControl = new FormChannelControl({
        id,
        eventId,
        tracksEnabled: props.tracksEnabled,
        awarenessUser,
        cableUrl: props.cableUrl,
        assistantEnabled,
        initialState: props.initialState,
      });

      // this.channelControl.ydoc.on("update", (update) => {
      //   console.log("Got update", update);
      //   logFormUpdate(this.channelControl.ydoc);
      // });
    }

    // FormEditorLoadingState renders Primer Box/Spinner/Text with sx props
    // during the connecting/syncing window. The ready branch's PrimerEditor
    // wraps in GregPrimerTheme downstream, but the loading branch only has
    // ThemeProvider — no StyleSheetManager guard. PrimerStyleGuard closes
    // that gap (same Turbo head-merge mechanism as the rest of GR-1599).
    // No BaseStyles here because the ready branch nests its own.
    this.root.render(
      <PrimerStyleGuard>
        <CollaborativeFormEditorWithReplay
          channelControl={this.channelControl}
          {...props}
        />
      </PrimerStyleGuard>
    );
  }

  disconnect() {
    super.disconnect();
    this.channelControl?.dispose();
    this.channelControl = undefined;
  }
}
